import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@ingka/button'

import TheaterModal from 'components/uiElements/TheaterModal'

require('./LoginPromptModal.scss')

interface LoginPromptModalProps {
    onClose: () => void
    onLogin: () => void
    onSignup: () => void
}

const LoginPromptModal = ({ onClose, onLogin, onSignup }: LoginPromptModalProps) => {
    const { t } = useTranslation()
    const wrapperRef = useRef(null)

    return (
        <div className="LoginPromptModal">
            <TheaterModal ref={wrapperRef} isOpen onClose={onClose}>
                <div className="modalContent">
                    <div className="modalHeader">{t('design.login to save')}</div>
                    <div className="modalBody">{t('design.login to save explain')}</div>
                    <div className="modalCTA">
                        <Button type="secondary" onClick={onSignup}>{t('login.sign up')}</Button>
                        <Button type="primary" onClick={onLogin}>{t('login.login')}</Button>
                    </div>
                </div>
            </TheaterModal>
        </div>
    )
}

export default LoginPromptModal
